export const SET_PURCHASES = "PURCHASES/SET_PURCHASES";
export const SET_PAGINATION = "PURCHASES/SET_PAGINATION";
